/**
 * FilterTabs Component
 * Tabs for switching between different table views (Shipments, Invoices, Charges)
 */
import { useMemo } from 'react';
import { GenericTabs } from 'src/presentations/components/molecules/tabs/GenericTabs';
import { ITabOption } from 'src/presentations/components/molecules/tabs/types';
import { TableTab } from './useTable';
import { useAnalyticsData } from '../context/AnalyticsDataContext';

export interface FilterTabsProps {
  setTableTab: (value: string) => void;
  tableTab: string;
}

export const FilterTabs = ({ setTableTab, tableTab }: FilterTabsProps) => {
  // Get totals and key metrics from context
  const { totals, keyMetricsResponse } = useAnalyticsData();

  // Table tabs options
  const optionTabs: ITabOption[] = useMemo(() => {
    const totalCounts = keyMetricsResponse?.keymetrics;

    return [
      {
        label: TableTab.SHIPMENTS,
        count: totals?.shipments ?? totalCounts?.noShipments ?? 0,
        value: TableTab.SHIPMENTS,
      },
      {
        label: TableTab.INVOICES,
        count: totals?.invoices ?? totalCounts?.noInvoices ?? 0,
        value: TableTab.INVOICES,
      },
      {
        label: TableTab.CHARGES,
        count: totals?.charges ?? totalCounts?.noCharges ?? 0,
        value: TableTab.CHARGES,
      },
    ];
  }, [keyMetricsResponse, totals]);

  return (
    <div className='flex items-center gap-12'>
      <GenericTabs options={optionTabs} onChange={setTableTab} defaultSelected={tableTab} className='!w-[28rem] xl:!w-[31.25rem]' />
    </div>
  );
};
